<div class="modal-header">
  <h4 class="modal-title">{{name}}</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div style=" width: 100% !important; display: flex; align-items: center; font-size:12px;">
    <div>Action:</div>&nbsp;&nbsp;
    <input type="radio" name="action" id="addUpdate" value="add">  &nbsp;<div>Add/Update End Time</div> &nbsp;&nbsp;

    <input type="radio" name="action" id="remove" value="remove">  &nbsp;<div>Remove End Time / Continue into Reliability</div> &nbsp;&nbsp;

    <input type="radio" name="action" id="cancel" value="cancel">  &nbsp;<div>Cancel Curtailments</div>
  </div>
  &nbsp;
  <div class="col-md-12">
    <fieldset class="p-2" style="width:100%; min-height: 100px; border:1px solid #7c7d7d!important;">
      <legend class="w-auto" style="font-size:1.2rem;">Specify New Curtailment End Time</legend>
      <form class="form-inline">
        <div class="form-group" style="font-size:14px;">
          <div class="input-group">
            <label>Event End Date:</label>&nbsp;
            <input id="endDate" class="form-control" placeholder="yyyy-mm-dd" [(ngModel)] ="date" name="ass" ngbDatepicker #dp="ngbDatepicker">
            <div class="input-group-append">
              <button class="btn btn-outline-secondary fa fa-calendar" (click)="dp.toggle()" type="button"></button>
            </div>
          </div>
          &nbsp;&nbsp;
          <div class="input-group">
            <label>Event End Time (24 hour):</label>&nbsp;
            <ngb-timepicker [(ngModel)]="time" name="endTime" size="small"></ngb-timepicker>
          </div>
        </div>
      </form>
    </fieldset>
  </div>
  <form>
    <div class="form-group">
      <div style="padding-left:15px; padding-right:0; margin-top:5px;">
        
        <ag-grid-angular #agGrid_EditCurtailmentTime style="width: 736px;; height: 100%;" class="ag-theme-balham"
        [paginationPageSize]="10" [pagination]="true"  [suppressRowClickSelection]="true"
        [rowSelection]="rowSelection" [defaultColDef]="defaultColDef"
        [gridOptions]="gridOptions_EditCurtailmentTime">
        </ag-grid-angular>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="activeModal.close('Close click')">Save</button>
  <button type="button" class="btn btn-outline-dark" (click)="activeModal.close('Cancel click')">Cancel</button>
</div> 
